import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function runScan({ domain, authorized, scanToken }) {
  const body = { domain, authorized };
  if (scanToken) body.scan_token = scanToken;
  const res = await axios.post(`${API}/scan`, body, { timeout: 45000 });
  return res.data;
}

export async function createChallenge({ domain }) {
  const res = await axios.post(`${API}/challenge`, { domain }, { timeout: 20000 });
  return res.data;
}

export async function verifyOwnership({ domain, challengeId }) {
  const res = await axios.post(
    `${API}/verify`,
    { domain, challenge_id: challengeId },
    { timeout: 20000 }
  );
  return res.data;
}
